<div class="redirect-link">
  <span class="redirect-link__text">redirecting...</span>
</div>
